import styled from "styled-components";
import { Button, ButtonProps } from "rebass";

interface IRadioButton extends ButtonProps {
  isActive: boolean;
}

export const RadioButton = styled(Button).attrs({ type: "button" })<IRadioButton>`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: ${({ isActive }) => isActive ? "#2b3061" : "#8083a0"}
  text-transform: capitalize;
  transition: all .4s;

  & + & {
    margin-top: 10px;
  }

  &:hover {
    background-color: ${({ theme: { colors } }) => colors["sp-blue-25"]};
  }
`;
